export class TabCommunicationBroadcastChannel {
    static isAvailable() {
        return typeof BroadcastChannel === 'function';
    }
    sendEvent(event) {
        this.broadcastChannel.postMessage(event);
    }
    onEvent(event, callback) {
        this.eventCallbacks.set(event, callback);
    }
    constructor(){
        this.CHANNEL_NAME = 'colonist';
        this.broadcastChannel = new BroadcastChannel(this.CHANNEL_NAME);
        this.eventCallbacks = new Map();
        this.broadcastChannel.addEventListener('message', (message)=>{
            const callback = this.eventCallbacks.get(message.data);
            callback === null || callback === void 0 ? void 0 : callback();
        });
    }
}
